import CmEpisodicItemPicture from '../cm-episodic-item-pictures/cm-episodic-item-picture.entity';
import { DEPARTMENTS } from '../enums/enums';
import Picture from '../pictures/picture.entity';
import PrEpisodicPropPicture from '../pr-episodic-prop-pictures/pr-episodic-prop-picture.entity';
import SetPiecePicture from '../set-piece-pictures/set-piece-picture.entity';
import { SosListResponse } from '../sos-response';
import { InventoryDepartment } from '../types';

export interface DeptSpecificInventoryPictureListResponse<
	T extends InventoryDepartment
> extends SosListResponse {
	listed: T extends DEPARTMENTS.CM
		? {
				CmEpisodicItemPicture: CmEpisodicItemPicture[];
				Picture: Picture[];
		  }
		: T extends DEPARTMENTS.PR
		? {
				PrEpisodicPropPicture: PrEpisodicPropPicture[];
				Picture: Picture[];
		  }
		: T extends DEPARTMENTS.SET
		? {
				SetPiecePicture: SetPiecePicture[];
				Picture: Picture[];
		  }
		: never;
}

export type InventoryPictureListResponse = DeptSpecificInventoryPictureListResponse<
	InventoryDepartment
>;
